
import { useNavigate, useParams } from "react-router-dom";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { Vspace } from '../components/styled/Separators.style'
import { composeUrl } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import FotoDannoCtpVeicolo from "../components/foto-danno-veicolo/FotoDannoCtpVeicolo";
import FotoPrivacyWarning from "../components/foto-privacy-warning/FotoPrivacyWarning";

/* istanbul ignore next */
const Trct_FotoDannoCtpVeicoloPage = () => {
    let navigate = useNavigate();
    let { token } = useParams();

    const goToNextStepHandler = () => {
        navigate(composeUrl(token, PATHS.TRCT_FOTO_ANGOLARE_TUO_VEICOLO))
    }

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.TRCT_FOTO_DANNO_CTP_VEICOLO}
            >
                <>
                    <Section>
                        <PageTitle>Foto del danno del veicolo della controparte</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>Scatta le foto del danno del veicolo della controparte. Ti ricordiamo che le foto devono essere attinenti al danno denunciato.</TextDefault>
                    </Section>

                    <FotoDannoCtpVeicolo />

                    <Section>
                        <FotoPrivacyWarning />
                    </Section>

                </>
            </PageContainerCmp>
        </>

    )
}

export default Trct_FotoDannoCtpVeicoloPage